enum BookingProtectionStatus {
  PENDING = 'PENDING',
  DUPLICATED = 'DUPLICATED',
}

export const checkBookingProtection = (booking?: {
  protection?: { status: BookingProtectionStatus | string }
}) => {
  if (!booking?.protection) return false

  return [BookingProtectionStatus.PENDING, BookingProtectionStatus.DUPLICATED].includes(
    booking.protection.status as BookingProtectionStatus,
  )
}
